const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'Osvědčení o registraci vozidla',
	'vehicleRegistrationDocument.description':
		'Nahrajte zřetelné fotografie požadovaných stran osvědčení o registraci vozidla.',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'Přední strana osvědčení o registraci',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Pořiďte zřetelnou fotografii přední strany osvědčení o registraci.',
	'vehicleRegistrationDocument.RegistrationDocument.headline':
		'Přední strana osvědčení o registraci',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'Přední strana osvědčení o registraci - příklad',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'Přední strana osvědčení o registraci',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title':
		'Zadní strana osvědčení o registraci',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Pořiďte zřetelnou fotografii zadní strany osvědčení o registraci.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline':
		'Zadní strana osvědčení o registraci',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'Zadní strana osvědčení o registraci - příklad',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'Zadní strana osvědčení o registraci',
	'vehicleRegistrationDocument.validationHeadline': 'Chybějící fotografie',
	'vehicleRegistrationDocument.validationDescription': 'Přidejte následující fotografie:',
	'landing.stepDescription.vehicleRegistrationDocument': 'Vyfoťte osvědčení o registraci vozidla',
	'review.stepDescription.vehicleRegistrationDocument': 'Osvědčení o registraci vozidla',
	'additionalDocuments.additionalDocumentImages': 'Fotografie dalších dokumentů',
	'additionalDocuments.headline.first': 'Dodatečné dokumenty',
	'additionalDocuments.headline.second':
		'Přidejte fotografie dalších dokumentů (např. Prohlášení pachatele kolize, poznámky policie, kupní smlouva vozidla a další dokumenty o majetku) - pokud nebyly pořízeny, stiskněte tlačítko přeskočit.',
	'approval.additionalCosts': 'Další náklady',
	'approval.button.approve': 'Přijímám nabídku',
	'approval.button.disapprove': 'Neakceptuji nabídku',
	'approval.calculationPDF': 'Přehled výpočtu PDF',
	'approval.description':
		'Zkontrolujte, zda je číslo vašeho bankářského účtu uvedeno níže, je správné. Je-li také potvrzeno, že je odhad a výše bude převedena na váš účet.',
	'approval.discount': 'Sleva',
	'approval.headline': 'Opravná částka',
	'approval.labourCosts': 'Pracovní náklady',
	'approval.lacquerCosts': 'Nátěry',
	'approval.lacquerMatCosts': 'Malířské materiály',
	'approval.payoutAmount': 'Částka výplaty',
	'approval.repairAmount': 'Opravná částka',
	'approval.repairAmountGross': 'Výše škody',
	'approval.retention': 'Zadržení',
	'approval.sparePartCosts': 'Náhradní díly',
	'approval.tax': 'káď',
	'blockedByDevice.headline': 'Online prohlídku není možné provést na počítači',
	'blockedByDevice.description':
		'Online prohlídku není možné provést na počítači.\r\nOtevřete si, prosím, zaslaný link na vašem mobilním telefonu / tabletu.\r\nDěkujeme.',
	'bodyshop.headline': 'Dílny ve vaší oblasti',
	'bodyshop.mainError': 'Semináře se mohou začít načítat ...',
	'bodyshop.mainLoader.loadingLocation': 'Určení vaší polohy ...',
	'bodyshop.mainLoader.loadingWorkshop': 'Načítání dílenských seminářů ...',
	'button.accept': 'S˙hlasÝm',
	'button.addLater': 'Vložit později',
	'button.backchangeImage': 'Zpět & změnit fotku',
	'button.call': 'Volání',
	'button.changeImage': 'Změnit fotku',
	'button.close': 'Zavřít',
	'button.contact': 'Kontakt',
	'button.continue': 'Pokračovat',
	'button.dataProtection': 'Ochrana dat',
	'button.deleteImage': 'Smazat fotku',
	'button.help': 'Upozornění',
	'button.imprint': 'Otisk',
	'button.liveChat': 'Živý chat',
	'button.next': 'Další',
	'button.ok': 'Ok',
	'button.onApproval': 'Získejte výpočet',
	'button.onCallback': 'Zpětné volání bylo přijato',
	'button.onExpertRequest': 'Žádost odborníka',
	'button.onInsuranceExpert': 'Řídící odborník na pojištění',
	'button.onLanding': 'Bez nástupu na palubu',
	'button.onOnboarding': 'Přihlášení',
	'button.onVideocall': 'Recenze videa',
	'button.payout': 'Ano, prosím zaplaťte',
	'button.prev': 'Předchozí stránka',
	'button.repair': 'Uspořádat párový',
	'button.select': 'Vybrat',
	'button.selectPhoto': 'Vyberte snímek',
	'button.showTutorial': 'Výukový program pro sledování',
	'button.showWhatsApp': 'WhatsApp-Message',
	'button.start': 'Začít',
	'calculationDetailsModal.additionalCosts': 'Další náklady',
	'calculationDetailsModal.labourCosts': 'Pracovní náklady',
	'calculationDetailsModal.lacquerCosts': 'Lacquerácost',
	'calculationDetailsModal.spareParts': 'Náhradní díly',
	'calculationDetailsModal.total': 'Celkový',
	'callback.description': 'Bohužel byl k dispozici výpočet',
	'callback.headline': 'Vaše poškození bylo posouzeno.',
	'completeDamageDescriptionModal.description': 'Popište prosím krátce, jak došlo k poškození.',
	'completeDamageDescriptionModal.headline': 'Upozornění',
	'completeDamageImages.description':
		'Přidejte alespoň 2 poškozené fotografie z různých vzdáleností.',
	'completeDamageImages.headline': 'Upozornění',
	'completeDashboardMileageModal.dashboardImage': 'Fotografie najetých kilometrů',
	'completeDashboardMileageModal.description': 'Poskytněte prosím níže uvedené informace:',
	'completeDashboardMileageModal.hasValidMileage': 'Kilometry vozidla',
	'completeDashboardMileageModal.headline': 'Upozornění',
	'completeFourAdditionalPicturesModal.description': 'Prosím vložte následující fotky vozidla:',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Fotografie najetých kilometrů',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage':
		'Fotografie palubní desky vozidla',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Fotografie VIN čísla vozidla',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Fotografie předního skla vozidla',
	'completeFourAdditionalPicturesModal.headline': 'Upozornění',
	'completeOverallDashboardImageModal.description': 'Prosím vložte následující fotky vozidla:',
	'completeOverallDashboardImageModal.hasOverallDashboardImage': 'Fotografie palubní desky',
	'completeOverallDashboardImageModal.headline': 'Upozornění',
	'completePayoutInformationModal.accountHolder': 'Držitel účtu',
	'completePayoutInformationModal.accountHolderIBAN': 'Majitel účtu IBAN',
	'completePayoutInformationModal.description': 'Prosím vložte následující fotky vozidla:',
	'completePayoutInformationModal.headline': 'Upozornění',
	'completePoliceReportModal.description': 'Prosím vložte následující fotky vozidla:',
	'completePoliceReportModal.hasAccidentOnAlcoholOrDrugs': 'Byli jste pod vlivem alkoholu?',
	'completePoliceReportModal.hasAccidentOwnFault': 'Už jste způsobili nehodu?',
	'completePoliceReportModal.hasDamageDescription': 'Popis poškození',
	'completePoliceReportModal.hasPoliceInformed': 'Byly zaznamenány incidenty v Polsku?',
	'completePoliceReportModal.hasPoliceReportExists': 'Existuje policejní zpráva??',
	'completePoliceReportModal.headline': 'Upozornění',
	'completeVehicleImagesModal.description': 'Prosím vložte následující fotky vozidla:',
	'completeVehicleImagesModal.hasVehicleImageFront': 'Fotografie přední části vozidla',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Levý předobok',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Pravý předobok',
	'completeVehicleImagesModal.hasVehicleImageLeft': 'Fotografie vozidla vlevo',
	'completeVehicleImagesModal.hasVehicleImageRear': 'Fotografie vozidla zpět',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Levý zadobok',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Pravý zadobok',
	'completeVehicleImagesModal.hasVehicleImageRight': 'Fotografie vozidla vpravo',
	'completeVehicleImagesModal.headline': 'Upozornění',
	'completeVehicleInformationModal.dashboardImage': 'Fotografie najetých kilometrů',
	'completeVehicleInformationModal.description': 'Prosím vložte následující fotky vozidla:',
	'completeVehicleInformationModal.hasValidMileage': 'Počet najetých kilometrů vozidla',
	'completeVehicleInformationModal.headline': 'Upozornění',
	'completeVehicleInformationModal.isRegistrationDocument2Uploaded':
		'Fotografie osvědčení o registraci vozidla (zadní strana)',
	'completeVehicleInformationModal.isRegistrationDocumentUploaded':
		'Fotografie z registrace vozidla',
	'completeVinModal.description': 'Poskytněte prosím níže uvedené informace:',
	'completeVinModal.hasVin': 'VIN vozidla',
	'completeVinModal.headline': 'Upozornění',
	'completeWindshieldImageModal.description': 'Prosím vložte následující fotky vozidla:',
	'completeWindshieldImageModal.hasWindshieldImage': 'Fotka čelního skla',
	'completeWindshieldImageModal.headline': 'Upozornění',
	'connectionError.description': 'Chyba připojení. Nahrajte prosím obrázek znovu.',
	'connectionError.title': 'Chyba připojení',
	'damageDescription.button.back': '« Zpáteční',
	'damageDescription.button.help': 'Upozornění',
	'damageDescription.button.next': 'Další »',
	'damageDescription.headline.first': 'Poškození Popis',
	'damageDescription.paragraph.first':
		'Stručně prosím popište, jak se poškození objevilo. Youáca také můžete použít k zobrazení funkce vašeho mobilního telefonu. Clická k umístění dalšího pole a držitele mikrofonu.',
	'damageDescription.placeholder':
		'Například: Na křižovatce mě z boku narazilo jiné auto. Můj přední levý blatník byl zatlačen dovnitř.',
	'damageImages.additionalImages': 'Dodatečné fotografie poškozených škod',
	'damageImages.description':
		'Přidatáateasta {imageCount, ánumber} ádamageá {imageCount, áplural, áoneá {photoáofáeachadamage} áotherá {photosáofáeachadamage.áFotografieby měla býtbýtnákovanáfromádifferentádistancesá (přiblížit / celý prvek)}} důležitě :ás',
	'damageImages.headline': 'Poškození obrázků',
	'damageImages.optionalDamageImages':
		'Volitelně přidejte další obrázky poškození, které dodatečně dokumentují poškození.',
	'damageImages.photo': 'fotografie poškození',
	'damageImagesExampleModal.headline': 'Příklad poškození',
	'dashboardImageExampleModal.headline': 'Příklad na palubní desce',
	'dashboardMileage.dashboard.paragraph':
		'Vyfoťte celkový počet ujetých kilometrů. Pokud máte elektronický tachometr, před focením prosím nastartujte motor.',
	'dashboardMileage.dashboard.title': 'Fotografie najetých kilometrů',
	'dashboardMileage.headline.first': 'Stav tachometru',
	'dashboardMileage.paragraph.first': 'Zadejte počet kilometrů vozidla.',
	'dashboardMileage.paragraph.mileageAutoFilled':
		'Počet najetých kilometrů byl automaticky vyplněn na základě načteného fotoaplikace',
	'dashboardMileage.placeholder': 'Zapište stav tachometru',
	'dataPrivacyModal.headline': 'Podmínky',
	'editPhoto.edit': 'Změnit',
	enumeration: '{position, áselect, áfirstá {} álastá {áandá} áotherá {, á}} {enumeration}',
	'feedback.button.send': 'Odeslat hodnocení',
	'feedback.description': ' ',
	'feedback.headline':
		'Fotografie nám byly úspěšně doručeny a spoluúčast 50% byla snížena na tu, kterou jsme dohodli ve smlouvě!',
	'feedback.headline.policyCheck':
		'Fotografie nám byly úspěšně doručeny a spoluúčast 50% byla snížena na tu, kterou jsme dohodli ve smlouvě!',
	'feedback.rating':
		'Na Vaší spokojenosti nám záleží, stačí kliknutí. Jak se Vám líbil tento nástroj pro online prohlídku vozidla? (5 hvězdiček = skvělý zážitek, 1 hvězdička = špatný zážitek)',
	'feedback.rating.policyCheck':
		'Na Vaší spokojenosti nám záleží, stačí kliknutí. Jak se Vám líbil tento nástroj pro online prohlídku vozidla? (5 hvězdiček = skvělý zážitek, 1 hvězdička = špatný zážitek)',
	'feedback.yourOpinion': 'Komentář',
	'fourAdditionalPictures.mileage.description':
		'Vyfoťte celkový počet ujetých kilometrů. Pokud máte elektronický tachometr, před focením prosím nastartujte motor.',
	'fourAdditionalPictures.mileage.enter': 'Zadejte počet kilometrů vozidla',
	'fourAdditionalPictures.mileage.title': 'Stav tachometru',
	'fourAdditionalPictures.overallDashboard.description':
		'Vyfoťte celou rozsvícenou přístrojovou desku.',
	'fourAdditionalPictures.overallDashboard.title': 'Přístrojová deska vozidla',
	'fourAdditionalPictures.title': 'Doplňující fotografie',
	'fourAdditionalPictures.vin.description':
		'Vyfoťte prosím VIN číslo svého vozidla. Naleznete to na těsnění dveří řidiče nebo v levém dolním rohu čelního skla.',
	'fourAdditionalPictures.vin.title': 'VIN vozidla',
	'fourAdditionalPictures.windshield.description':
		'Vyfoťte prosím podrobně přední sklo svého vozidla.',
	'fourAdditionalPictures.windshield.title': 'Přední sklo vozidla',
	'fourAdditionalPicturesExampleModal.button.close': 'Zavřít',
	'fourAdditionalPicturesExampleModal.headline.first': 'Další obrázky',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Vzorová Fotografie',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Vzorová Fotografie',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Vzorová Fotografie',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Vzorová Fotografie',

	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Pravý předobok',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Pravý zadobok',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Levý zadobok',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Levý předobok',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle': 'Vzorová Fotografie',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'Vzorová Fotografie',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle': 'Vzorová Fotografie',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle': 'Vzorová Fotografie',

	'fourPerspectivesExampleModal.button.close': 'Zavřít',
	'fourPerspectivesExampleModal.headline.first': 'Vozidlo',
	'helpModal.description':
		'Nezískáte už žádné další s jednou další odpovědí na vaše dotazy ohledně aplikace? ÁKontaktujte prosím! Á Budeme rádi, když vám rádi:',
	'helpModal.headline': 'Upozornění',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Vzorová Fotografie',
	'imageRecognitionMismatchModal.headline': 'Skutečně jste přiložil správnou fotku?',
	'insuranceExpert.description':
		'Děkuji mnohokrát. Vaše poškození bylo posouzeno. Brzy se s vámi spojíme, abychom s vámi projednali další postup.',
	'insuranceExpert.headline': 'Kontaktujeme vás krátce.',
	'label.details': 'Detaily',
	'landing.aboutEasyclaim': 'Co je EasyClaim?',
	'landing.aboutPolicyCheck': 'Co je PolicyCheck?',
	'landing.changeLang': 'Chcete-li změnit jazyk, klikněte sem.',
	'chooseLang.headline': 'Vyberte preferovaný jazyk',
	'landing.dataPrivacyLink': 'Pokračovaním souhlasíte s podmínkami',
	'landing.headline': 'Odhad opravy v několika krocích:',
	'landing.headline.policyCheck': 'Vítejte',
	'landing.paragraph': 'Prohlídku zvládnete ve třech krocích',
	'landing.stepDescription.additionalDocuments': 'Vyfoťte prohlášení pachatelů',
	'landing.stepDescription.damageDescription': 'Popište poškození',
	'landing.stepDescription.damageImages': 'Vezměte fotografii z poškození',
	'landing.stepDescription.feedback': 'Ohodnoťte nás',
	'landing.stepDescription.fourAdditionalPictures': 'Nahrajte fotografie',
	'landing.stepDescription.fourDiagonalPerspectives': 'Pořiďte požadovanou fotodokumentaci',
	'landing.stepDescription.vehicleImages': 'Vezměte fotografie vozidla',
	'landing.stepDescription.vehicleInformation': 'Podrobnosti o vozidle',
	'landing.stepDescription.vinPicture': 'Přidejte fotografii VIN na vozidle',
	'landing.termsAndConditionsLink': 'Pokračovaním souhlasíte s podmínkami',
	'landing.termsAndConditionsLinkDescription': ' ',
	'loader.error': 'Stránku se nepodařilo načíst. Prosím zkuste to znovu později. Zkusit znovu...',
	'loader.loading': 'Načítání dat ...',
	'mainError.tryAgain': 'Zkus to znovu',
	'mainMenu.contact': 'Kontaktujte nás',
	'mainMenu.contact.officeHours': 'Naše servisní časy: pondělí - pátek 8:00 - 20:00',
	'mainMenu.contactDescription':
		'Máte nějaké dotazy? zavolejte nám pomocí tohoto telefonního čísla: {hotlineNumber}',
	'mainMenu.dataPrivacy': 'Ochrana dat',
	'mainMenu.description': 'Kliknutím na tlačítko zobrazíte zásady ochrany osobních údajů.',
	'mainMenu.headline': 'Ochrana dat',
	'mainMenu.imprintDescription': 'Kliknutím na tlačítko otisk otevřete.',
	'mainMenu.imprintLink': 'Otisk',
	'onboarding.button.finish': 'Pojďme se podívat',
	'onboarding.button.next': 'Další »',
	'onboarding.headline.first': 'Pořizujte snímky poškození',
	'onboarding.headline.second': 'Nechť spočítat',
	'onboarding.headline.third': 'Získejte výpočet',
	'onboarding.link.dataPrivacy': 'Přijměte ochranu',
	'onboarding.link.skip': 'Přeskočit',
	'onboarding.paragraph.first':
		'Expert na automobily použije obrázky k výpočtu výše poškození vozidla.',
	'onboarding.paragraph.second':
		'Jednoduše nahrajte fotografii z registrace vozidla a poškození automobilu.',
	'onboarding.paragraph.third':
		'Během několika hodin obdržíte výpočet. Nyní se můžete rozhodnout vyplatit částku za opravu nebo nechat vozidlo opravit v dílně',
	'overallDashboardImage.description': 'Vyfoťte celou rozsvícenou přístrojovou desku.',
	'overallDashboardImage.headline': 'Přístrojová deska vozidla',
	'overallDashboardImage.title': 'Přístrojová deska vozidla',
	'overallDashboardImageExampleModal.button.close': 'Zavřít',
	'overallDashboardImageExampleModal.headline.first': 'Příklad fotky přístrojové desky',
	'payout.button.back': '« Zpáteční',
	'payout.button.help': 'Upozornění',
	'payout.button.payoutConfirm': 'Potvrďte výplatu »',
	'payout.headline.first': 'Bankaúčetní číslo',
	'payout.headline.second': 'Držitel účtu',
	'payout.headline.third': 'Číslo účtu',
	'payout.paragraph': 'Poskytněte prosím číslo svého bankovního účtu pro kompenzaci platby.',
	'perspective.front.left': 'vpředu vlevo',
	'perspective.front.right': 'vpředu vpravo',
	'perspective.rear.left': 'zadní levý',
	'perspective.rear.right': 'zadní pravý',
	'registrationDocumentExampleModal.headline': 'Fotografie z registrace, příklad osvědčení',
	'resolverequest.button.continue': 'Pokračovat',
	'resolverequest.headline': 'Vyžadují se další informace',
	'resolverequest.onload': 'Načítání požadavku ...',
	'resolverequest.onload.error':
		'Při načítání dotazu se objevila další chyba. Prosím, udělejte dobrý výběr.',
	'resolverequest.perspective.paragraph':
		'FotografierenáSieáIhráFahrzeugáschrńgávonávorneálinksáundávonáhintenárechts.áDasáKfz-Kennzeichenámussálesbarásein.áDieáBilderáwerdenáben ÷ tigt, áumáeinenáGesamteze',
	'resolverequest.question.headline': 'Máme otázku',
	'review.button.back': '« Zpáteční',
	'review.button.close': 'Zavřít',
	'review.button.help': 'Upozornění',
	'review.button.next': 'Další',
	'review.editViewButton': 'Viewá / á Upravit',
	'review.headline.first': 'Kontrola',
	'review.paragraph.first':
		'Ujistěte se, že jsou vloženy všechny fotografie a klikněte na "Dokončit". Následně obdržíte jejich přehled.',
	'review.stepDescription.damageImages': 'Poškození obrázků',
	'review.stepDescription.fourDiagonalPerspectives': 'Obrázky z perspektiv',
	'review.stepDescription.mileage': 'Stav tachometru',
	'review.stepDescription.overallDashboard': 'Obrázek palubní desky',
	'review.stepDescription.vehicleFrontPerspectiveImage': 'Obrázky z levé a levé strany vozidla',
	'review.stepDescription.vehicleImages': 'Fotografie vozidla',
	'review.stepDescription.vehicleInformation': 'Podrobnosti o vozidle',
	'review.stepDescription.vehicleLeftPerspectiveImage': 'Obrázky z pravého předního vozidla',
	'review.stepDescription.vehicleRearPerspectiveImage': 'Obrázky z pravo-pravého vozidla',
	'review.stepDescription.vehicleRightPerspectiveImage': 'Obrázky z levé strany vozidla',
	'review.stepDescription.vinPicture': 'VIN vozidla',
	'review.stepDescription.windshield': 'Obrázek o větru',
	'thanks.headline.first': 'Velice si ceníme poskytnutého hodnocení!',
	'thanks.paragraph.first': 'Děkujeme, že nám věříte',
	'thanksForFeedback.headline.first': 'Zpětná vazba!',
	'thanksForFeedback.paragraph.first':
		'Váš názor na naši službu je důležitý důležitý. „Neustále pracujeme na zlepšení“ Easy Claim „a vaše zpětná vazba“ je důležitá klíčová „naše úspěch“.',
	'timeout.bottom': ' ',
	'timeout.headline.first': 'Odkaz na aplikaci již není aktivní!',
	'tooManyAttempts.description':
		'Bohužel jste dosáhli na maximální počet maximálních otevřených relací. Naši poradci se s vámi spojí.',
	'tooManyAttempts.title': 'Příliš mnoho sezení',
	'tutorialModal.headline.first': 'Co je za EasyClaim??',
	'tutorialModal.headline.first.policyCheck': 'Co je za PolicyCheck?',
	'tutorialModal.paragraph.first':
		'EasyClaim je vhodný pro téměř všechna poškození těla automobilu. Vaše obrázky poškození a popis nehody budou předány přímo jednomu z našich 350 odborníků na automobily, kde budou obrázky analyzovány a nárokovány. Všechny naše týmy odborníků pracovaly v dílně prakticky roky samy a velmi dobře rozuměly svému řemeslu. Kromě toho již více než 16 let zkoumáme nároky a příjmy z údržby téměř od všech významných pojišťovacích společností a výrobců vozidel. Vaše data budou porovnána s více než 50 miliony ověřených transakcí z minulosti a doplněna praktickým know-how našich automobilových odborníků. Kromě toho jsme v průběhu let vybudovali velmi rozsáhlou databázi. Víme, co každý šroub u každého výrobce stojí za každý model a jaké kroky jsou nutné k výměně nebo opravě automobilové součásti.',
	'tutorialModal.paragraph.first.policyCheck':
		'PolicyCheck je rychlá kontrola vozidla. Proces kontroly se skládá z 8 jednoduchých kroků.',
	'tutorialModal.paragraph.second':
		'Všechny tyto okolnosti mohou dovolit poskytnout realistickou cenu odhadnout na tak krátkou dobu.',
	'upload.message':
		'Vaše data budou nahrána. V závislosti na vašem připojení k internetu může tento proces trvat několik minut.',
	'vehicleImages.backOverview': 'Zadní fotka vozidla',
	'vehicleImages.description':
		'Vyfoťte své vozidlo uhlopříčně podle instrukcí: levý předobok, levý zadobok, pravý předobok, pravý zadobok. SPZ musí být dobře viditelná a čitelná na všech 4 fotkách.',
	'vehicleImages.details.first': 'Levý předobok',
	'vehicleImages.details.fourth': 'Pravý zadobok',
	'vehicleImages.details.frontleft':
		'Pořiďte si fotoobraz z vozidla, který je celý vpředu a je vedle něj. Theálicenselaplate by měla být čitelná.',
	'vehicleImages.details.rearright':
		'Pořiďte si fotoobraz z vozidla, který má celý prostor a světlo na stranu. Theálicenselaplate by měla být čitelná.',
	'vehicleImages.details.second': 'Levý zadobok',
	'vehicleImages.details.third': 'Pravý předobok',
	'vehicleImages.frontOverview': 'Frontáphotoáofátheávehicle',
	'vehicleImages.leftFrontOverview': 'Levý předobok',
	'vehicleImages.leftOverview': 'Levá fotka vozidla',
	'vehicleImages.leftRearOverview': 'Levý zadobok',
	'vehicleImages.overviewPhotos': 'Vozidlo',
	'vehicleImages.overviewPhotos.subtitle': 'Pořiďte fotodokumentaci vozidla',
	'vehicleImages.rightFrontOverview': 'Pravý předobok',
	'vehicleImages.rightOverview': 'Pravá fotka vozidla',
	'vehicleImages.rightRearOverview': 'Pravý zadobok',
	'vehicleImagesExampleModal.button.close': 'Zavřít',
	'vehicleImagesExampleModal.headline.first': 'Vozidlo',
	'vehicleInformation.button.back': '« Zpáteční',
	'vehicleInformation.button.help': 'Upozornění',
	'vehicleInformation.button.next': 'Další »',
	'vehicleInformation.headline.first': 'Podrobnosti o vozidle',
	'vehicleInformation.headline.fourth': 'Fotografie osvědčení o registraci (zadní strana)',
	'vehicleInformation.headline.second': 'Fotografie osvědčení o registraci (přední)',
	'vehicleInformation.paragraph.first':
		'Pořiďte si fotoaparát z registrační osvědčení (přední strana)',
	'vehicleInformation.paragraph.fourth':
		'Pořiďte si fotoapráce z registrace vozidla, osvědčení (reverzní)',
	'vinImagesExampleModal.button.close': 'Zavřít',
	'vinImagesExampleModal.headline.first': 'Příklad VIN',
	'vinPicture.description':
		'Vyfoťte VIN vozidla. Najdete ho zpravidla na hraně otevřených dvěří u řidiče nebo vlevo dole pod čelním sklem.',
	'vinPicture.headline': 'VIN vozidla',
	'vinPicture.title': 'VIN vozidla',
	'waitForAudit.callBack': 'Pro další dotazy, áweáareáhappyátoáhelpáyou:',
	'waitForAudit.description':
		'Tyto údaje byly úspěšně odeslány. Naši odborníci budou zpravidla zkontrolováni, že škoda byla získána na základě vašich údajů a generována jako kalkulace s druhým2hodinovým (po-pá8aam-8apm, ano',
	'waitForAudit.description.damageFound': 'Děkujeme, že nám věříte',
	'waitForAudit.description.damageNotFound': 'Děkujeme, že nám věříte',
	'waitForAudit.thankYou': 'Děkuju!',
	'waitforAudit.finish': 'Dokončit',
	'windshieldExampleModal.button.close': 'Zavřít',
	'windshieldExampleModal.headline.first': 'Příklad fotky čelního skla',
	'windshieldImage.description': 'Vyfoťte celé čelní sklo vozidla.',
	'windshieldImage.headline': 'Čelní sklo vozidla',
	'windshieldImage.title': 'Čelní sklo vozidla',
	'withoutPayout.description': 'Měli byste si přát pár',
	'withoutPayout.footer': 'Kontaktujeme vás, že budeme moci pokračovat v dalším postupu.',
	'withoutPayout.headline': 'Rádi vás podpoříme!',

	'testcasemodal.headline': 'Upozornění na testovací případ!',
	'testcasemodal.accept': 'Přijmout',
	'testcasemodal.paragraph': 'Uvědomte si, že jde o testovací případ!',
	'testcasewarningalert.paragraph': 'Toto je testovací případ!',

	'invalidFile.size.title': 'Nesprávná velikost fotografie',
	'invalidFile.size.description': 'Fotografie je větší než požadovaná velikost.',
	'invalidFile.extension.title': 'Tento typ souboru není podporován',
	'invalidFile.extension.description':
		'Tento typ souboru není podporován. Podporované typy: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp.',

	'serviceErrorModal.headline': 'Unexpected error occured',
	'serviceErrorModal.close': 'OK',

	'serviceErrorModal.paragraph.first': 'Unexpected error has occured, please reload the page.',
	'serviceErrorModal.paragraph.second': 'If the error is persistent, reach out for support.',
	'serviceErrorModal.paragraph.details':
		'Please share any additional detail (e.g., screenshot) that could help us reproduce the error.',
};

export default messages;
